import {defaultAnimationEnter, defaultAnimationLeave, defaultAnimationOnce} from "../animations/default";
import {singlePostAnimationOnce, singlePostAnimationLeave} from "../animations/single-post";
import {
    singleProjectAnimationEnter, singleProjectAnimationEnterFromAnotherProject,
    singleProjectAnimationLeave, singleProjectAnimationLeaveForAnotherProject,
    singleProjectAnimationLeaveForHome
} from "../animations/single_project";
import {
    projectsAnimationEnter,
    projectsAnimationLeaveToSingleProject,
    projectsAnimationOnce
} from "../animations/projects";

const transitions = [
    {
        name: 'default-transition',
        sync: false,
        once(data) {
            // create your stunning leave animation here
            //console.log('default-transition once');
            defaultAnimationOnce(data.next.container)
        },
        leave: (data) => defaultAnimationLeave(data.current.container),
        enter(data) {
            // create your amazing enter animation here
            defaultAnimationEnter(data.next.container);
        }
    },
    {
        name: 'blog-single',
        to: {
            namespace: [
                'blog_single'
            ]
        },
        sync:false,
        once(data) {
            // create your stunning leave animation here
            // console.log('blog-single once');
            singlePostAnimationOnce(data.next.container)
        },
        leave: (data) => defaultAnimationLeave(data.current.container),
        enter(data) {
            // create your amazing enter animation here
            // console.log('blog-single enter');
            singlePostAnimationOnce(data.next.container);
        }
    },
    {
        name: 'leave-blog-single',
        from: {
            namespace: [
                'blog_single'
            ]
        },
        sync:false,
        once(data) {
            defaultAnimationOnce(data.next.container)
        },
        leave: (data) => singlePostAnimationLeave(data.current.container),
        enter(data) {
            defaultAnimationEnter(data.next.container);
        }
    },
    {
        name: 'leave-blog-single-to-home',
        from: {
            namespace: [
                'blog_single'
            ]
        },
        to: {
            namespace: [
                'projects'
            ]
        },
        sync:false,
        leave: (data) => singlePostAnimationLeave(data.current.container),
        enter(data) {
            projectsAnimationEnter(data.next.container);
        }
    },
    {
        name: 'leave-project-single',
        from: {
            namespace: [
                'project_single'
            ]
        },
        sync:false,
        once(data) {
            defaultAnimationOnce(data.next.container)
        },
        leave: (data) => singleProjectAnimationLeave(data.current.container),
        enter(data) {
            defaultAnimationEnter(data.next.container);
        }
    },
    {
        name: 'to-project-single',
        to: {
            namespace: [
                'project_single'
            ]
        },
        sync:false,
        once(data) {
            defaultAnimationOnce(data.next.container)
        },
        leave: (data) => defaultAnimationLeave(data.current.container),
        enter(data) {
            singleProjectAnimationEnter(data.next.container);
        }
    },
    {
        name: 'project-single-to-project-single',
        from: {
            namespace: [
                'project_single'
            ]
        },
        to: {
            namespace: [
                'project_single'
            ]
        },
        sync:false,
        leave: (data) => {
            return singleProjectAnimationLeaveForAnotherProject(data.current.container)

        },
        enter(data) {
            // console.log("@@@");
            // console.log(data.current.container);
            singleProjectAnimationEnterFromAnotherProject(data.next.container, data.current.container);

        }
    },
    {
        name: 'to_home',
        to: {
            namespace: [
                'projects'
            ]
        },
        sync: false,
        once(data) {
            // create your stunning leave animation here
            // console.log('to_home once');
            projectsAnimationOnce(data.next.container);
        },
        leave: (data) => defaultAnimationLeave(data.current.container),
        enter(data) {
            // create your amazing enter animation here
            // console.log('to_home enter');
            projectsAnimationEnter(data.next.container);
        }
    },
    {
        name: 'from_home_to_project',
        from: {
            namespace: [
                'projects'
            ]
        },
        to: {
            namespace: [
                'project_single'
            ]
        },
        sync: false,
        leave: (data) => {
            return projectsAnimationLeaveToSingleProject(data.current.container)
        },
        enter(data) {
            // create your amazing enter animation here
            console.log('enter project single from home');

            return singleProjectAnimationEnter(data.next.container);
        }
    },
    {
        name: 'from_project_to_home',
        to: {
            namespace: [
                'projects'
            ]
        },
        from: {
            namespace: [
                'project_single'
            ]
        },
        sync: false,
        leave: (data) => {
            console.log("leave single project to home");
            return singleProjectAnimationLeaveForHome(data.current.container)
        },
        enter(data) {
            // create your amazing enter animation here
            console.log('enter home from single project');

            return projectsAnimationEnter(data.next.container);
        }
    },
];
export  {transitions};